export function WistiaVideoCarousel() {
    const setComponent = ($videoSection) => {
        const $carouselContainer = $videoSection.find('.owl-carousel');

        // responsive settings
        const responsiveSettings = {
            0: { items: 2, slideBy: 1 },
            320: { items: 3, slideBy: 1 }
        };
        responsiveSettings[768] = {
            items: 4,
            slideBy: 1
        };

        responsiveSettings[1024] = {
            items: 4,
            slideBy: 1
        };

        // set carousel
        $carouselContainer.owlCarousel({
            loop: false,
            nav: true,
            dots: false,
            autoplay: false,
            autoplayTimeout: 0,
            lazyLoad: true,
            responsive: responsiveSettings,
            rewind: false
        });     

        $carouselContainer.find('.carousel-item').on('click', function () {
            $carouselContainer.find('.carousel-item.active').removeClass('active');
            $(this).addClass('active');

            const $iframe = $videoSection.find('iframe[data-video="' + $(this).data('video') + '"]');
            $videoSection.find('.wistia_embed.active').removeClass('active');
            $iframe.addClass('active');
        })
    }

    const init = () => {
        $(document).ready(function () {
            if ($('.widget-wistia-videos').length) {
                $('.widget-wistia-videos .video-section').each(function () {
                    setComponent($(this));
                }) 
            }
        });        
    }

    init();
}